import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { SketchButton } from './sketchy';
import { classNames } from '../utils/classNames';
import { goToSignIn, type LandingSignInPlacement } from '../utils/landingSignIn';

type LandingSignInButtonProps = {
  placement: LandingSignInPlacement;
  className?: string;
  'data-testid'?: string;
};

/** Header Sign in — compact label; hero uses its own copy via goToSignIn directly. */
export default function LandingSignInButton({
  placement,
  className,
  'data-testid': testId,
}: LandingSignInButtonProps) {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <SketchButton
      type="button"
      onClick={() => goToSignIn(navigate, placement)}
      variant="primary"
      className={classNames('px-4 py-2 text-xs sm:text-sm', className)}
      data-testid={testId ?? 'landing-sign-in'}
    >
      <span className="hidden sm:inline">{t('landing.header.createAccount')}</span>
      <span className="sm:hidden">{t('landing.header.signUp')}</span>
    </SketchButton>
  );
}
